import { httpClient, ApiResponse } from '@/utils';
import {
  IAdminsListResponse,
  IGetAdminsListDTO,
  ICreateAdminDTO,
  IUpdateAdminDTO,
  AdminsEndpoints,
  IAdmin,
} from '@/models/admins.model';
import omit from 'lodash.omit';

class AdminsAPI {
  static getAdminsList(data: IGetAdminsListDTO): ApiResponse<IAdminsListResponse> {
    return httpClient.get<IAdminsListResponse>(AdminsEndpoints.ADMINS_LIST, { params: data });
  }

  static getAdminDetails(id: string): ApiResponse<IAdmin> {
    return httpClient.get<IAdmin>(`${AdminsEndpoints.ADMINS}/${id}`);
  }

  static deleteAdmin(id: string): ApiResponse<IAdmin> {
    return httpClient.delete<IAdmin>(`${AdminsEndpoints.ADMINS}/${id}`);
  }

  static updateAdminDetails(data: IUpdateAdminDTO): ApiResponse<IAdmin> {
    return httpClient.post<IAdmin>(`${AdminsEndpoints.ADMINS}/${data?.id}`, omit({ ...data }, 'id'));
  }

  static activateAdmin(id: string): ApiResponse<IAdmin> {
    return httpClient.post<IAdmin>(`${AdminsEndpoints.ADMINS}/${id}/activate`);
  }

  static deactivateAdmin(id: string): ApiResponse<IAdmin> {
    return httpClient.post<IAdmin>(`${AdminsEndpoints.ADMINS}/${id}/deactivate`);
  }

  static createAdmin(data: ICreateAdminDTO): ApiResponse<IAdmin> {
    return httpClient.put<IAdmin>(AdminsEndpoints.ADMINS, { ...data });
  }
}

export default AdminsAPI;
